import { useConditionValuesFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionValuesError = () => {
  const fieldPath = useConditionValuesFieldPath();
  const { getHasErrorFromFieldPath } = useQueryErrorStateContext();
  const errorFromFieldPath = getHasErrorFromFieldPath(fieldPath);

  return errorFromFieldPath;
};
